
if (!customElements.get('product-video-player')) {
  class VideoWithText extends HTMLElement {
    firstIntoView = true;

    constructor() {
      super();
      this.videoElement = this.querySelector('[data-plyr-video]');
      this.desktopVideoLink = this.getAttribute('data-video-desktop').replaceAll("/'", '"');
      this.mobileVideoLink = this.getAttribute('data-video-mobile').replaceAll("/'", '"');
      this.autoplay = (this.getAttribute('data-auto-play') ?? 'false') == 'true';

      const isMobile = `(max-width: 768px)`;
      const isMobileMQL = window.matchMedia(isMobile);
      isMobileMQL.addEventListener('change', (event) => {
        if (event.matches && this.mobileVideoLink) {
          if (this.videoElement.hasAttribute('data-plyr-embed-id')) {
            this.changeVideo(this.mobileVideoLink, 'youtube');
          } else {
            this.changeVideo(this.mobileVideoLink);
          }
        } else {
          if (this.videoElement.hasAttribute('data-plyr-embed-id')) {
            this.changeVideo(this.desktopVideoLink, 'youtube');
          } else {
            this.changeVideo(this.desktopVideoLink);
          }
        }
      });
      this.createVideo(isMobileMQL.matches);
    }

    onScroll() {
      if (this.firstIntoView) {
        const scrollBottom = window.scrollY + window.innerHeight;
        if (scrollBottom > $(this).offset().top && this.player.paused) {
          this.player.muted = true;
          this.player.play();
          this.firstIntoView = false;
          this.removeEventListener('scroll', this.onScroll.bind(this));
        }
      }
    }

    createVideo(isMobile) {
      if (isMobile && this.mobileVideoLink) {
        if (this.videoElement.hasAttribute('data-plyr-embed-id')) {
          this.videoElement.setAttribute('data-plyr-embed-id', this.mobileVideoLink);
        } else {
          this.videoElement.src = this.mobileVideoLink;
        }
      }

      this.player?.pause();
      // 懒初始化 video
      const player = new Plyr(this.videoElement, {
        autoplay: false,
        resetOnEnd: false,
        muted: this.autoplay,
        loop: {
          active: false,
        },
        controls: [
          'play-large', // The large play button in the center
          // 'restart', // Restart playback
          'rewind', // Rewind by the seek time (default 10 seconds)
          'play', // Play/pause playback
          'fast-forward', // Fast forward by the seek time (default 10 seconds)
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'duration', // The full duration of the media
          'mute', // Toggle mute
          'volume', // Volume control
          'captions', // Toggle captions
          'settings', // Settings menu
          'pip', // Picture-in-picture (currently Safari only)
          'airplay', // Airplay (currently Safari only)
          // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
          'fullscreen', // Toggle fullscreen
        ],
        settings: ["captions", "quality", "speed", "loop"],
        captions: {
          active: true,
          language: "auto",
          update: true,
        },
        tooltips: {
          controls: false,
          seek: false,
        },
        youtube: {
          loop: 0,
          title: false,
          showinfo: 0,
          rel: 0,
          cc_lang_pref: 1,
          cc_load_policy: 1,
        },
        //ratio: '16:9',
        quality: { default: 1080, options: [4320, 2880, 2160, 1440, 1080, 720] },
      });
      this.player = player;

      if (isMobile && this.mobileVideoLink) {
        if (this.videoElement.hasAttribute('data-plyr-embed-id')) {
          this.changeVideo(this.mobileVideoLink, 'youtube');
        } else {
          this.changeVideo(this.mobileVideoLink);
        }
      }

      if (this.autoplay) {
        window.addEventListener('scroll', this.onScroll.bind(this));
      }
    }

    changeVideo(src, provider) {
      let source = {
        src: src,
      };
      if (provider) {
        source.provider = provider;
      }
      this.player.source = {
        type: 'video',
        sources: [source],
      };
    }

    distoryVideo() {
      this.player.destroy();
    }
  }
  customElements.define('product-video-player', VideoWithText);
}